import React from 'react'
import PropTypes from 'prop-types'

import Text from './Text'
import { Status } from './Status'
import colors from '@/settings/styleSettings'
import { Line } from './Line'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: -12,
    marginBottom: 12,
  },
  text: {
    fontSize: 12,
    fontFamily: 'Inter-Bold',
    color: colors.strongGray,
  },
}

const InfoLine = ({ text, informed }) => (
  <>
    <div style={styles.container}>
      <Text style={styles.text}>{text}</Text>
      <Status
        text={informed ? 'Sim' : 'Não'}
        textColor={informed ? colors.strongRed : colors.primary}
      />
    </div>
    <Line style={{ marginBottom: 24 }} />
  </>
)

InfoLine.propTypes = {
  text: PropTypes.string.isRequired,
  informed: PropTypes.bool,
}

InfoLine.defaultProps = {
  informed: null,
}

export default InfoLine
